import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function sasReducer(state = initialState.sas, action){
    switch (action.type) {
        case types.CONSULTA_SAS:
            
            return action.sas;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/sasReducer.js
 **/